import type { AgentConfig } from "~/shared/types";

import AgentIcon from "./AgentIcon.vue";
import Icon from "./Icon.vue";

const config: AgentConfig = {
  name: "Clay",
  icon: Icon,
  agentIcon: AgentIcon,
  color: "#40BAFE",
  helpUrl: "https://help.dartai.com/en/articles/11726726-ai-account-research-agent",
  configFields: [
    {
      key: "webhook",
      type: "text",
      label: "Webhook URL",
      placeholder: "Your Clay webhook URL",
    },
    {
      key: "apiKey",
      type: "password",
      label: "Auth token",
      placeholder: "Your Clay auth token",
    },
    {
      type: "webhook",
      key: "webhook",
    },
  ],
};

export default config;
